var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cal-elec" },
    [
      _c("map-control", {
        attrs: { icon: _vm.calcSvg, title: "电量计算" },
        on: {
          click: function($event) {
            _vm.visible = true
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "cal-elec-dialog",
          attrs: {
            width: "600px",
            title: "电量计算",
            modal: false,
            "append-to-body": "",
            visible: _vm.visible
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "calc-content" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    "label-position": "right",
                    "label-width": "130px",
                    model: _vm.form,
                    rules: _vm.rules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "机组型号", prop: "turbineTypeId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "calc-select",
                          attrs: { "popper-class": "wind-farm-select " },
                          model: {
                            value: _vm.form.turbineTypeId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "turbineTypeId", $$v)
                            },
                            expression: "form.turbineTypeId"
                          }
                        },
                        _vm._l(_vm.turbineTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.typeName,
                              value: item.turbineTypeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "K", prop: "K" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入K参数" },
                        model: {
                          value: _vm.form.K,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "K", $$v)
                          },
                          expression: "form.K"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "A（m/s）", prop: "A" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入A参数" },
                        on: {
                          input: val => {
                            _vm.handleParamsChange(val, "A")
                          }
                        },
                        model: {
                          value: _vm.form.A,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "A", $$v)
                          },
                          expression: "form.A"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "U（m/s）", prop: "U" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入U参数" },
                          on: {
                            input: val => {
                              _vm.handleParamsChange(val, "U")
                            }
                          },
                          model: {
                            value: _vm.form.U,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "U", $$v)
                            },
                            expression: "form.U"
                          }
                        },
                        [_vm._v(">")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "空气密度（kg/m³）", prop: "density" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入密度" },
                        model: {
                          value: _vm.form.density,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "density", $$v)
                          },
                          expression: "form.density"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "尾流损失（%）", prop: "flowLoss" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入尾流损失（%）" },
                        model: {
                          value: _vm.form.flowLoss,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "flowLoss", $$v)
                          },
                          expression: "form.flowLoss"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "综合折减系数（%）",
                        prop: "synthesizeLoss"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入综合折减系数（%） 参考值60%～85%"
                        },
                        model: {
                          value: _vm.form.synthesizeLoss,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "synthesizeLoss", $$v)
                          },
                          expression: "form.synthesizeLoss"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "calc-result" }, [
                _c("div", { staticClass: "calc-text" }, [
                  _c("span", [_vm._v("计算结果: 满发小时 ")]),
                  _c("span", { staticClass: "hour-space" }, [
                    _vm._v(_vm._s(_vm.hour))
                  ]),
                  _c("span", [_vm._v("(h)")])
                ])
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "wind-stand-footer flex-reverse",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.handleCalcClick } },
                [_vm._v("计算")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }